import { z } from "zod";
import { asUserId, ok } from "@pack-it-up/shared";
import { firestoreTimestamp, parseDto, toTimestamp } from "./common.js";
// --- a friend's denormalised profile: users/{me}/friends/{friendId} ---
// `userId` is the doc id (the friend's id); `since` is bookkeeping, not a domain field.
export const FriendProfileDtoSchema = z.object({
    displayName: z.string(),
    email: z.string(),
    photoUrl: z.string().optional(),
    since: firestoreTimestamp().optional(),
});
export const toDomainUserProfile = (raw, userId) => {
    const p = parseDto(FriendProfileDtoSchema, raw, "UserProfile");
    if (!p.ok)
        return p;
    const d = p.value;
    return ok({
        userId: asUserId(userId),
        displayName: d.displayName,
        email: d.email,
        ...(d.photoUrl !== undefined ? { photoUrl: d.photoUrl } : {}),
    });
};
export const toUserProfileDto = (u) => ({
    displayName: u.displayName,
    email: u.email,
    ...(u.photoUrl !== undefined ? { photoUrl: u.photoUrl } : {}),
});
// --- friend request ---
const PublicRefSchema = z.object({
    userId: z.string(),
    displayName: z.string(),
    photoUrl: z.string().optional(),
});
const publicRefToDomain = (r) => ({
    userId: asUserId(r.userId),
    displayName: r.displayName,
    ...(r.photoUrl !== undefined ? { photoUrl: r.photoUrl } : {}),
});
export const FriendRequestDtoSchema = z.object({
    id: z.string(),
    fromUserId: z.string(),
    toUserId: z.string(),
    status: z.enum(["pending", "accepted", "ignored"]),
    createdAt: firestoreTimestamp(),
    fromProfile: PublicRefSchema.optional(),
    toProfile: PublicRefSchema.optional(),
});
export const toDomainFriendRequest = (raw) => {
    const p = parseDto(FriendRequestDtoSchema, raw, "FriendRequest");
    if (!p.ok)
        return p;
    const d = p.value;
    return ok({
        id: d.id,
        fromUserId: asUserId(d.fromUserId),
        toUserId: asUserId(d.toUserId),
        status: d.status,
        createdAt: d.createdAt,
        ...(d.fromProfile !== undefined ? { fromProfile: publicRefToDomain(d.fromProfile) } : {}),
        ...(d.toProfile !== undefined ? { toProfile: publicRefToDomain(d.toProfile) } : {}),
    });
};
export const toFriendRequestDto = (r) => ({
    id: r.id,
    fromUserId: r.fromUserId,
    toUserId: r.toUserId,
    status: r.status,
    createdAt: toTimestamp(r.createdAt),
    ...(r.fromProfile !== undefined
        ? { fromProfile: { userId: r.fromProfile.userId, displayName: r.fromProfile.displayName, ...(r.fromProfile.photoUrl !== undefined ? { photoUrl: r.fromProfile.photoUrl } : {}) } }
        : {}),
    ...(r.toProfile !== undefined
        ? { toProfile: { userId: r.toProfile.userId, displayName: r.toProfile.displayName, ...(r.toProfile.photoUrl !== undefined ? { photoUrl: r.toProfile.photoUrl } : {}) } }
        : {}),
});
//# sourceMappingURL=identity.mapper.js.map